import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import Index from '@/components/Index'
// import Projects from '@/components/Projects'
import Project from '@/components/Project'
import Information from '@/components/Information'
import News from '@/components/News'
import NotFound from '@/components/NotFound'
import AppPage from '@/components/AppPage'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/projects',
      name: 'Projects',
      meta: { slug: 'projects' },
      component: Information
      // component: Projects
    },
    {
      path: '/projects/:slug',
      name: 'Project',
      component: Project,
      meta: { type: 'project' }
    },
    {
      path: '/experiences/:slug',
      name: 'Experience',
      component: Project,
      meta: { type: 'experience' }
    },

    {
      path: '/information',
      name: 'Information',
      meta: { slug: 'information' },
      component: Information
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      meta: { slug: 'privacy-policy' },
      component: AppPage
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/news/:slug',
      name: 'Post',
      component: News
    },

    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }
  ],
  scrollBehavior (_to, _from, savedPosition) {
    // return new Promise((resolve) => {
    //   setTimeout(() => {
    //     if (savedPosition) {
    //       resolve(savedPosition)
    //     } else {
    //       resolve({ x: 0, y: 0 })
    //     }
    //   }, 1000)
    // })
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js